import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useCreateDeclarationMutation(params?: HydraMutationParams) {
  return useHydraMutation('api/declarations', {
    ...params,
  });
}
